import { render, staticRenderFns } from "./GuiasLista.vue?vue&type=template&id=07d40f6c&scoped=true&"
import script from "./GuiasLista.vue?vue&type=script&lang=js&"
export * from "./GuiasLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d40f6c",
  null
  
)

export default component.exports